import React, { useEffect, useState } from 'react'
import './HintSection.sass'
import { Topic } from '../../types/data'
import HintBubble, { HintItemType } from '../../components/ChatMessage/HintBubble'
import { useTranslation } from 'react-i18next'

interface Props {
    topics: Topic[]
    onSelect: (item: Topic) => void
}

const TopicSection: React.FC<Props> = (props) => {
    const { t } = useTranslation()
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setIsVisible(true)
        }, 300)
    }, [])

    if (props.topics !== null && props.topics.length > 0) {
        return (
            <div className="topic-section">
                <span
                    className={`topic-section__title ${
                        isVisible ? 'topic-section__title-visible' : 'topic-section__title-notvisible'
                    }`}
                >
                    <div className={'topic-section__image'} />

                    {t('general.suggestions-label')}
                </span>

                {props.topics !== null &&
                    props.topics.map((topic, index) => (
                        <HintBubble
                            key={topic.title}
                            item={topic}
                            index={index}
                            type={HintItemType.topic}
                            onSelect={(item) => {
                                props.onSelect(item as Topic)
                            }}
                        />
                    ))}
            </div>
        )
    }

    return null
}

export default TopicSection
